import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBridgeAction, IBridgeTriggerParameters, ISetBridgeParameterPayload } from './types';
import { removeAction } from './utils';

export interface IBridgeState {
  // list of bridge actions
  actions: IBridgeAction[];
  // currently active action
  current: number;
  // is feature loaded
  loaded: boolean;
  // custom parameters for triggers
  params: IBridgeTriggerParameters;
}

export const initialState: IBridgeState = {
  actions: [],
  current: 0,
  loaded: false,
  params: {},
};

export const statePropName = 'bridge';

const bridgeSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initBridge(state, action: PayloadAction<number>) {},
    requestBridge(state) {
      state.loaded = false;
    },
    updateBridgeActions(state, action: PayloadAction<IBridgeAction[]>) {
      state.actions = action.payload;
      state.loaded = true;
    },
    detectBridgeAction() {},
    activateBridgeAction(state, action: PayloadAction<number>) {
      state.current = action.payload;
    },
    ctaBridgeAction(state, action: PayloadAction<number>) {},
    closeBridgeAction(state, action: PayloadAction<number>) {},
    removeBridgeAction(state, action: PayloadAction<number>) {
      state.actions = removeAction(state.actions, action.payload);
      state.current = 0;
    },
    setBridgeParameter: {
      reducer(state, action: PayloadAction<ISetBridgeParameterPayload>) {
        const { paramName, paramValue } = action.payload;
        state.params[paramName] = paramValue;
      },
      prepare(paramName: string, paramValue: string) {
        return { payload: { paramName, paramValue } };
      },
    },
  },
});

export const BridgeActions = bridgeSlice.actions;
export default bridgeSlice.reducer;
